import React, { Component } from 'react'

class Popup extends Component {
    componentDidMount() {
        const wrapper = document.getElementById("popup-wrapper");
        const button = document.getElementById("popup-button");

        button.addEventListener('click', () => wrapper.classList.add('active'));
        wrapper.addEventListener('click', e => {
            if(e.target === wrapper) {
                wrapper.classList.remove('active');
            }
            
        });
    }

    render() {
        return (
            <div className="popup-wrapper" id="popup-wrapper">
                <div className="popup">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Popup;